var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 1.89136V5.33348C9.66683 5.80018 9.66683 6.03354 9.75766 6.2118C9.83755 6.3686 9.96504 6.49609 10.1218 6.57598C10.3001 6.66681 10.5335 6.66681 11.0002 6.66681H14.4423M9.66683 14.1667H4.66683M11.3335 10.8334H4.66683M14.6668 8.3236V14.3334C14.6668 15.7335 14.6668 16.4336 14.3943 16.9684C14.1547 17.4388 13.7722 17.8212 13.3018 18.0609C12.767 18.3334 12.067 18.3334 10.6668 18.3334H5.3335C3.93336 18.3334 3.2333 18.3334 2.69852 18.0609C2.22811 17.8212 1.84566 17.4388 1.60598 16.9684C1.3335 16.4336 1.3335 15.7335 1.3335 14.3334V5.66675C1.3335 4.26662 1.3335 3.56655 1.60598 3.03177C1.84566 2.56137 2.22811 2.17892 2.69852 1.93923C3.2333 1.66675 3.93336 1.66675 5.3335 1.66675H8.00998C8.62145 1.66675 8.92719 1.66675 9.21491 1.73582C9.47 1.79707 9.71386 1.89808 9.93754 2.03515C10.1898 2.18975 10.406 2.40594 10.8384 2.83832L13.4953 5.49517C13.9276 5.92755 14.1438 6.14374 14.2984 6.39604C14.4355 6.61972 14.5365 6.86358 14.5978 7.11867C14.6668 7.40639 14.6668 7.71213 14.6668 8.3236Z",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayNote);
export default __webpack_public_path__ + "static/media/gray-note.9d82678db0ccfb7c2741401de318ed83.svg";
export { ForwardRef as ReactComponent };